/*=========================================================================================
  File Name: moduleDashboardActions.js
  Description: Dashboard Module Actions
==========================================================================================*/

import sensorAlertGQL from "@/http/requests/cbs/sensor_alert_gql";
import dashboardDeviceListGQL from "@/http/requests/cbs/dashboard_device_list_gql.js";
import categoryGQL from "@/http/requests/cbs/category_gql";

export default {
	fetchDashboardDeviceListGql({ commit }, payload) {
		return new Promise((resolve, reject) => {
			dashboardDeviceListGQL
				.initData(payload)
				.then(response => {
					commit("SET_IS_FETCHED_DEVICES", true);
					commit("SET_DEVICES", response.devices);
					// commit("SET_CATEGORIES", response.categories);
					commit("SET_DEVICES_STATUS", response.devicesStatus);
					resolve(response);
				})
				.catch(error => {
					commit("SET_IS_FETCHED_DEVICES", false);
					reject(error);
				});
		});
	},

	fetchSensorAlerts({ commit }, payload) {
		return new Promise((resolve, reject) => {
			sensorAlertGQL
				.fetchSensorAlerts(payload)
				.then(response => {
					commit("SET_SENSOR_ALERTS", response.sensorAlerts);
					commit("SET_IS_FETCHED_SENSOR_ALERTS", true);
					resolve(response);
				})
				.catch(error => {
					commit("SET_IS_FETCHED_SENSOR_ALERTS", false);
					reject(error);
				});
		});
	},
	fetchCategories({ commit }, payload) {
		return new Promise((resolve, reject) => {
			try {
				categoryGQL
					.fetchCategories(payload)
					.then(response => {
						commit("SET_CATEGORIES", response.categories);
						resolve(response);
					})
					.catch(error => {
						reject(error);
					});
			} catch (error) {
				console.error("[Dashboard] Action fetchCategories", error);
			}
		});
	}
};
